import styled from 'styled-components';
import {
  desktop_breakpoint,
  desktop_breakpoint_extended,
} from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';

const HomePageStyles = styled.div`
  .posts-recent,
  .posts-trending {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    margin-top: 4px;
  }
  .headline-essentials {
    padding-top: 0;
    padding-bottom: 18px;
  }
  .headline-trending {
    padding-top: 32px;
    padding-bottom: 6px;
  }
  .headline-mostrecent {
    padding-top: 12px;
    padding-bottom: 8px;
  }

  @media screen and (min-width: ${desktop_breakpoint}px) {
    .constrained-width {
      margin-top: 40px;
    }
  }

  @media screen and (min-width: ${desktop_breakpoint_extended}px) {
    .posts-recent,
    .posts-trending {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      grid-gap: 20px;
    }
    .headline-essentials {
      padding-top: 44px;
      padding-bottom: 22px;
    }
    .headline-trending {
      padding-top: 54px;
      padding-bottom: 18px;
    }
    .headline-mostrecent {
      padding-bottom: 18px;
    }
  }
`;

export default HomePageStyles;
